// extracted by mini-css-extract-plugin
export var cartContainer = "_oy-4";
export var gray = "_oy-1";
export var itemContainer = "_oy-2";
export var itemDetails = "_oy-3";
export var strong = "_oy-0";